module.exports = __webpack_public_path__ + "static/media/ls.f04f4878.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ls.png
// module id = 1910
// module chunks = 0